/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class TelemetryBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation telemetryGetStatus
   */
  static readonly TelemetryGetStatusPath = '/api/telemetry/status';

  /**
   * Get API state.
   *
   * Returns with API Health state
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telemetryGetStatus$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  telemetryGetStatus$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, TelemetryBackendService.TelemetryGetStatusPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get API state.
   *
   * Returns with API Health state
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telemetryGetStatus$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  telemetryGetStatus$Plain(params?: {
  }): Observable<string> {

    return this.telemetryGetStatus$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Get API state.
   *
   * Returns with API Health state
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `telemetryGetStatus$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  telemetryGetStatus$Json$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, TelemetryBackendService.TelemetryGetStatusPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get API state.
   *
   * Returns with API Health state
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `telemetryGetStatus$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  telemetryGetStatus$Json(params?: {
  }): Observable<string> {

    return this.telemetryGetStatus$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
